//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import DeviceParameterModel from './device-parameter.model';
import Device from './device.model';

@Injectable({
  providedIn: 'root'
})
export class DeviceParameterService extends Service<DeviceParameterModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/aqu/deviceparam/');
  }

  public addDeviceParams(device: DeviceParameterModel) {
    return new Promise<Array<DeviceParameterModel>>((resolve, reject) => {
      const request = this.httpClient.post<Array<DeviceParameterModel>>(`${this.baseUrl}${this.serviceUrl}addDeviceParams`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public updateDeviceParams(device: Device) {
    return new Promise<Array<DeviceParameterModel>>((resolve, reject) => {
      const request = this.httpClient.put<Array<DeviceParameterModel>>(`${this.baseUrl}${this.serviceUrl}updateDeviceParams`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public getAllDeviceParams() {
    return new Promise<Array<DeviceParameterModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<DeviceParameterModel>>(`${this.baseUrl}${this.serviceUrl}details?pageSize=2000&order=new`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public getUnassignedDevices() {
    return new Promise<Array<DeviceParameterModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<DeviceParameterModel>>(`${this.baseUrl}${this.serviceUrl}unassigned/devices`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
